import { Link } from "@/atoms"
import { isScanning } from "@/domain/scan-history"
import { getPolicyExceptionPath } from "@/helpers/signin.helpers"
import { PullRequestOutlined } from "@/icons"
import { CellWithStatusIndicator } from "@/molecules/CellWithStatusIndicator"
import { LinkButton } from "@/molecules/LinkButton"

import styles from "./ScanIdCell.module.scss"

import type { TFunction } from "@/hooks/useTranslation"
import type { getScanHistorySelector } from "@/pages/GovernancePage/applications/scan-history/useScanHistory.selector"

// canReview: the user may decide policy exceptions, checked once for the whole table.
export const ScanID = ({
  t,
  canReview
}: {
  t: TFunction
  canReview: boolean
}) =>
  function ScanIdCellComponent(
    value: string,
    record: ReturnType<typeof getScanHistorySelector>["data"][number]
  ) {
    const isUrlEmpty = !record.reportUrl
    const status = isScanning(record) ? "loading" : undefined

    // Admins review a pending exception request from its pull request's latest scan
    if (canReview && record.isPolicyExceptionToReview)
      return (
        <CellWithStatusIndicator status={status}>
          <LinkButton
            size="small"
            type="primary"
            icon={<PullRequestOutlined />}
            to={getPolicyExceptionPath(record.scanId)}
          >
            {t("governance.scanHistory.review")}
          </LinkButton>
        </CellWithStatusIndicator>
      )

    return (
      <CellWithStatusIndicator status={status}>
        {isUrlEmpty && <span className={styles.text}>{value}</span>}
        {!isUrlEmpty && (
          <Link target="_blank" href={record.reportUrl}>
            {value}
          </Link>
        )}
      </CellWithStatusIndicator>
    )
  }
